






import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import ArchiveIcon from '../assets/archive.svg';
import ContactsIcon from '../assets/contacts.svg';
import ContentIcon from '../assets/content.svg';
import ContractsIcon from '../assets/contracts.svg';
import DashboardIcon from '../assets/dashboard.svg';
import DealboardIcon from '../assets/dealboard.svg';
import RoomsIcon from '../assets/rooms.svg';
import DocumentsIcon from '../assets/documents.svg';
import LibraryIcon from '../assets/library.svg';
import ProductsIcon from '../assets/products.svg';
import ReportsIcon from '../assets/reports.svg';
import type { SidebarLabel } from '../types/enums/sidebar-label';

export default defineComponent({
  name: 'GlobalSidebarIcon',
  components: {
    ArchiveIcon,
    ContactsIcon,
    ContentIcon,
    ContractsIcon,
    DashboardIcon,
    DealboardIcon,
    RoomsIcon,
    DocumentsIcon,
    LibraryIcon,
    ProductsIcon,
    ReportsIcon,
  },
  props: {
    type: {
      type: String as PropType<SidebarLabel>,
      required: true,
    },
  },
});
